import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    theme: 'light',
    sidebarOpen: false,
    notifications: [],
    modal: {
      open: false,
      type: null,
      data: null,
    },
    loading: false,
    toast: {
      open: false,
      message: '',
      severity: 'info',
    },
    expandedSections: {
      basicInfo: true,
      revenueExpenses: true,
      personnel: true,
      population: true,
    },
  },
  reducers: {
    toggleTheme: (state) => {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    openModal: (state, action) => {
      state.modal = {
        open: true,
        type: action.payload.type,
        data: action.payload.data,
      };
    },
    closeModal: (state) => {
      state.modal = {
        open: false,
        type: null,
        data: null,
      };
    },
    addNotification: (state, action) => {
      state.notifications.push({
        id: Date.now(),
        ...action.payload,
      });
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      );
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    showToast: (state, action) => {
      state.toast = {
        open: true,
        message: action.payload.message,
        severity: action.payload.severity || 'info',
      };
    },
    hideToast: (state) => {
      state.toast.open = false;
    },
    toggleSection: (state, action) => {
      const section = action.payload;
      state.expandedSections[section] = !state.expandedSections[section];
    },
    expandAllSections: (state) => {
      Object.keys(state.expandedSections).forEach((key) => {
        state.expandedSections[key] = true;
      });
    },
    collapseAllSections: (state) => {
      Object.keys(state.expandedSections).forEach((key) => {
        state.expandedSections[key] = false;
      });
    },
  },
});

export const {
  toggleTheme,
  toggleSidebar,
  openModal,
  closeModal,
  addNotification,
  removeNotification,
  setLoading,
  showToast,
  hideToast,
  toggleSection,
  expandAllSections,
  collapseAllSections,
} = uiSlice.actions;

export default uiSlice.reducer;